module.exports = __webpack_public_path__ + "static/media/laptop.0e9e57fc.svg";